<article id="payment-gateway">
  <!-- Payment success content -->
  @if (transactionSuccessful) {
    <section id="payment-wrapper">
      <div class="bl-bg-color--white bl-border bl-border-radius--8 bl-padding--24 bl-padding-sm--48">
        <header
          class="bl-font-color--black bl-font-weight--800 bl-font-size--22 bl-text-align--center bl-margin-bottom--8 bl-margin-top--0 bl-margin-top-sm--24"
        >
          <i class="cu-check-circle bl-font-color--success bl-font-size--64 bl-display--block bl-margin-bottom--8"></i>
          {{ isACH() ? 'Payment Submitted' : 'Payment Approved' }}
        </header>
        @if (isACH()) {
          <p class="bl-margin-bottom--8">
            <span class="bl-display--block bl-font-color--steel bl-font-size--14 bl-text-align--center"
              >Your ACH payment will be processed within 2-3 days. Please check back to make sure your accounts are funded.</span
            >
          </p>
        }
        <div class="bl-display--flex bl-align-items--center bl-width--100 bl-margin-bottom--24 bl-border-top--solid bl-margin-top--24">
          <p class="bl-flex--auto bl-font-color--black bl-font-weight--800 bl-margin-bottom--0 bl-margin-top--24">Payment Information</p>
          @if (!icgConfig.disablePrint) {
            <button
              type="button"
              id="print-receipt"
              (click)="print()"
              class="bl-padding--8 bl-padding-top--24 bl-font-color--primary bl-print-hide"
              data-toggle="tooltip"
              title="Print/PDF"
            >
              <i class="cu-print bl-font-size--18"></i>
            </button>
          }
        </div>
        @if (paymentDetails?.paymentAmount) {
          <p class="bl-margin-bottom--16">
            <span class="bl-display--block bl-font-color--steel bl-font-size--14"> {{ isACH() ? 'Amount submitted' : 'Amount paid' }} </span>
            <span class="bl-display--block bl-font-color--black bl-font-weight--800">{{ paymentDetails.paymentAmount | currency }}</span>
          </p>
        }
        @if (paymentDetails?.cardNumber || paymentDetails?.accountNumber) {
          <p class="bl-margin-bottom--24">
            <span class="bl-display--block bl-font-color--steel bl-font-size--14">Payment source</span>
            @if (paymentDetails?.cardNumber) {
              <span class="bl-display--block bl-font-color--black bl-font-weight--800">
                Card ending in •••{{ paymentDetails.cardNumber }}
              </span>
            }
            @if (paymentDetails?.accountNumber) {
              <span class="bl-display--block bl-font-color--black bl-font-weight--800">
                {{ paymentDetails.accountType }} ending in •••{{ paymentDetails.accountNumber }}
              </span>
            }
          </p>
        }
        @if (paymentDetails?.paymentDate) {
          <p class="bl-margin-bottom--24">
            <span class="bl-display--block bl-font-color--steel bl-font-size--14"> {{ isACH() ? 'Submitted on' : 'Paid on' }} </span>
            <span class="bl-display--block bl-font-color--black bl-font-weight--800">{{
              paymentDetails.paymentDate | date : 'LLLL dd, yyyy'
            }}</span>
          </p>
        }
        @if (paymentDetails?.trackingNumber) {
          <p class="bl-margin-bottom--24">
            <span class="bl-display--block bl-font-color--steel bl-font-size--14">
              {{ isACH() ? 'Payment tracking number' : 'Confirmation Number' }}</span
              >
              <span class="bl-display--block bl-font-color--black bl-font-weight--800 bl-text-transform--uppercase">{{
                paymentDetails.trackingNumber
              }}</span>
            </p>
        }
      </div>
    </section>
  }

  <div
    [hidden]="paymentTypes.length <= 1 || transactionSuccessful"
    class="bl-margin-bottom--16 bl-bg-color--white bl-border-radius--16 bl-border bl-padding--24"
  >
    <!-- TODO: Discuss with PO/UX - we may want to convert this into a fieldset and add "how would you like to pay?" here. -->
    <div class="bl-max-width--1136 bl-width--100 bl-margin-bottom--24">
      <div class="bl-font-color--black bl-font-weight--900 bl-font-size--22">Funding Type</div>
        <div
          class="bl-font-color--black bl-font-size--14 bl-padding-top--4 bl-required"
          [ngClass]="{ 'bl-validation-error': this.icgConfig?.invalidPaymentType, '': !this.icgConfig?.invalidPaymentType }"
        >
          Decide your funding type below.
        </div>
    </div>
    @for (item of paymentTypes; track item; let i = $index; let isLast = $last) {
      <div
        class="bl-check-wrap blds-padding-y--8 blds-padding-left--16 bl-padding-bottom--8"
      >
        <input
          type="radio"
          [id]="i"
          name="radioPayment"
          [value]="item.value"
          (click)="selectedPayment(item.value)"
          [ngClass]="{ 'bl-validation-error': this.icgConfig?.invalidPaymentType, '': !this.icgConfig?.invalidPaymentType }"
        />
        <label
          class="bl-label blds-padding-left--8"
          [ngClass]="{ 'bl-font-color--error': this.icgConfig?.invalidPaymentType, '': !this.icgConfig?.invalidPaymentType }"
          [for]="i"
          >{{ item.name }}</label
        >
      </div>
    }
    <div class="bl-padding-y--8 blds-padding-left--16">
      <span
        class="bl-margin-right--16"
        [ngClass]="{ 'bl-font-color--error': this.icgConfig?.invalidPaymentType, '': !this.icgConfig?.invalidPaymentType }"
      ></span>
    </div>
  </div>

  <!-- Payment wrapper -->
  @if (showIframe()) {
    @if (icgConfig.iframeHeading) {
      <h3
        [innerHTML]="icgConfig.iframeHeading"
        class="bl-font-size--24 bl-font-weight--800 bl-font-color--black"
      ></h3>
    }
    <!-- Payment iFrame -->
    <div class="bl-overflow--auto">
      <div class="bl-width--100">
        <iframe
          title="Payment Gateway iFrame"
          id="payment-gateway-iframe"
          name="payment-gateway-iframe"
          [src]="trustedUrl"
          width="400px"
          [ngClass]="{ 'ach-min-height': isACH(), 'cc-min-height': !isACH() }"
        >
        </iframe>
      </div>
    </div>
  }

  <!-- This is the error alert -->
  <ea-alert
    [showAlert]="transactionError || transactionApproved === false"
    alert-id="paymentErrorAlert"
    alertStatus="error"
    heading="Hmm... something didn't work."
    [message]="errorMessage"
    [ngClass]="{ 'bl-display--block bl-max-width--tablet-width': transactionError || !transactionApproved === false }"
  >
  </ea-alert>
</article>
